import React from 'react';
import {connect} from 'react-redux';
import RegistrationInputFirstStep from './RegistrationInputFirstStep';
import RegistrationInputSecondStep from './RegistrationInputSecondStep';


function RegistrationPopupInput(props) {
  if (props.regInputCurStep === 1) {
    return <RegistrationInputFirstStep {...props} />;
  } else {
    return <RegistrationInputSecondStep {...props} />;
  }
}

export default connect(
  (state) => ({
    regInputCurStep: state.registrationPopupReducer.regInputCurStep
  }),
  () => ({})
)(RegistrationPopupInput);



/** WEBPACK FOOTER **
 ** ./src/components/RegistrationPopup/elements/RegistrationPopupInput.jsx
 **/